import * as THREE from 'three';

export class Defect{
	constructor(defectOption){
		this.defectOption = defectOption;		
	}
}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/models/Defect.js